/**
 * SplashBackground component.
 */
import FlavourConfig from '@shared/config/flavours';
import ScreenUtils from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled splash background.
 */
const SplashBackground = styled.img<React.CSSProperties>`
  position: absolute;
  width: ${ScreenUtils.widthRatio * 1920}px;
  height: ${ScreenUtils.widthRatio * 1080}px;
`;

/**
 * Default props for splash background.
 */
SplashBackground.defaultProps = {
  src: FlavourConfig.splashBackground
    ? FlavourConfig.images.background
    : undefined,
};

export default withImage(SplashBackground);
